import React from 'react';

import {
  LandingSelectedEntities,
} from '../../../components';
import { APP_OPTIONS } from '../../../config/constants';

const LandingSelectedProjects = ({ id, entity }) => {

  return (
    <LandingSelectedEntities
      id={id}
      type="projects"
      link={APP_OPTIONS.parameters.links.viewAllProjects}
      entities={entity.getIn(['field_landing_selected_projects'])}
      title={entity.getIn(['field_title', 0, 'value'])}
    />
  );
};

export default LandingSelectedProjects;
